import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  ImageInfo,
  ItemCastCharacterRelation,
  ItemSubType,
  ItemType,
  MainItemBasic,
  MainType
} from '@irohalab/mira-sdk-angular';
import { DEFAULT_IMAGE_INFO, formatPublicTime, imageRatio } from '../utils';
import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';


interface CastItem {
  id: string;
  name?: string;
  nameCn?: string;
  coverImage: ImageInfo;
  imageRatio: number;
}

interface ItemWithRelation {
  name?: string;
  nameCn?: string;
  type?: ItemType;
  subType?: ItemSubType;
  itemId: string | null | undefined;
  relationType: string | undefined;
  coverImage: ImageInfo;
  imageRatio: number;
  publicTime: string;
  isCollection: boolean;
  castList: CastItem[];
}

@Component({
    selector: 'app-character-item-cast-list',
    imports: [
    UIResponsiveImageWrapper
],
    templateUrl: './character-item-cast-list.component.html',
    styleUrl: './character-item-cast-list.component.less'
})
export class CharacterItemCastListComponent implements OnChanges {
  @Input()
  relationMainItems!: MainItemBasic[];

  @Input()
  relations!: ItemCastCharacterRelation[];

  itemsWithRelation: ItemWithRelation[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeItemsWithRelation();
  }

  private initializeItemsWithRelation(): void {
    if (this.relationMainItems?.length > 0 && this.relations?.length > 0) {
      const itemIdSet = new Set<string>();
      for (const relation of this.relations) {
        if (itemIdSet.has(relation.mainItemId)) {
          continue;
        }
        itemIdSet.add(relation.mainItemId);
        const mainItem = this.relationMainItems.find(item => item.id === relation.mainItemId);
        if (mainItem) {
          let itemImage = mainItem.coverImage;
          if (!itemImage) {
            itemImage = DEFAULT_IMAGE_INFO;
          }
          const castIdList = this.relations
            .filter(rel => rel.mainItemId === relation.mainItemId)
            .map(rel => rel.mainItemId);
          const itemWithRelation: ItemWithRelation = {
            itemId: mainItem.id,
            name: mainItem.name,
            nameCn: mainItem.nameCn,
            type: mainItem.type,
            subType: mainItem.subType,
            relationType: relation.relationType,
            coverImage: itemImage,
            imageRatio: imageRatio(itemImage),
            publicTime: formatPublicTime(mainItem.publicTime),
            isCollection: mainItem.isCollection,
            castList: this.relationMainItems
              .filter(item => castIdList.includes(item.id) && item.mainType === MainType.Person)
              .map(cast => {
                let castImage = cast.coverImage;
                if (!castImage) {
                  castImage = DEFAULT_IMAGE_INFO;
                }
                return {
                  id: cast.id,
                  name: cast.name,
                  nameCn: cast.nameCn,
                  coverImage: castImage,
                  imageRatio: imageRatio(castImage),
                } as CastItem;
              })
          }

          this.itemsWithRelation.push(itemWithRelation);
        }
      }
    }
  }
}
